import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

const useAuth = () => {
  const { isAuthenticated, isValidatingToken, loginUser, impersonatedUser } = useSelector((state) => state.auth);
  let {
    assignedDivisions,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedProjects,
    assignedSuppliers,
    assignedContracts,
    assignedFleets,
    dateFormat,
    dateTimeFormat,
    permissionSet,
    // added for petrohub user
    permissions,
    userToRoles,
    userAddressList,
    userContactList,
    isPetroHubUser,
    userGlobalFilterPetroHub,
    // end of petrohub user additions
    username,
    isClientOnHold
  } = loginUser || {};

  const { token } = loginUser || {};
  let { user } = loginUser || {};
  if (impersonatedUser) {
    user = impersonatedUser.user;
  }

  let timezone = user ? user.Timezone : '';

  if (impersonatedUser) {
    assignedDivisions = impersonatedUser.assignedDivisions;
    assignedClients = impersonatedUser.assignedClients;
    assignedLocations = impersonatedUser.assignedLocations;
    assignedSourceSystems = impersonatedUser.assignedSourceSystems;
    assignedProjects = impersonatedUser.assignedProjects;
    assignedSuppliers = impersonatedUser.assignedSuppliers;
    assignedFleets = impersonatedUser.assignedFleets;
    assignedContracts = impersonatedUser.assignedContracts;
    dateFormat = impersonatedUser.dateFormat;
    dateTimeFormat = impersonatedUser.dateTimeFormat;
    permissionSet = impersonatedUser.permissionSet;
    permissions = impersonatedUser.permissions;
    userToRoles = impersonatedUser.userToRoles;
    userAddressList = impersonatedUser.userAddressList;
    userContactList = impersonatedUser.userContactList;
    userToRoles = impersonatedUser.userToRoles;
    username = impersonatedUser.Username;
    isClientOnHold = impersonatedUser.isClientOnHold;
    isPetroHubUser = impersonatedUser.isPetroHubUser;
    userGlobalFilterPetroHub = impersonatedUser.userGlobalFilterPetroHub;

    if (impersonatedUser.user) {
      timezone = impersonatedUser.user.Timezone;
    }

    if (!dateFormat) {
      dateFormat = 'mm-dd-yyyy';
    }
  }

  const isAuthorized = useCallback(
    ({ permissionCode, right }) => {
      if (!permissionSet || !permissionCode) {
        return false;
      }
      if (isPetroHubUser && isEmpty(permissions)) return false;
      if (isPetroHubUser) {
        // console.log('Checking authorization for permission code: ', permissions, permissionCode);
        const options = permissions.filter((permission) => permission.Code.toLowerCase() === permissionCode.toLowerCase())[0]?.Options;
        // return permissions.some((permission) => permission.Code.toLowerCase() === permissionCode.toLowerCase());
        return permissionSet[permissionCode.toLowerCase()] && options && options.includes(right);
      }
      // console.log('Checking authorization for permission code: ', permissions, permissionCode);
      // const options = permissions.filter((permission) => permission.Code.toLowerCase() === permissionCode.toLowerCase())[0]?.Options;
      // console.log('Options for permission code ', permissionCode, ': ', options);
      return permissionSet[permissionCode.toLowerCase()];
    },
    [permissionSet, permissions, isPetroHubUser]
  );
  const isAuthorizedPetrohub = useCallback(
    ({ permissionCode }) => {
      if (!permissions || !permissionCode) {
        return false;
      }
      // console.log('Checking authorization for permission code: ', permissions, permissionCode);
      return permissions.some((permission) => permission.Code.toLowerCase() === permissionCode.toLowerCase());
    },
    [permissions]
  );
  return {
    isAuthenticated,
    isValidatingToken,
    user,
    token,
    username,
    permissionSet,
    assignedDivisions,
    assignedFleets,
    assignedContracts,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedProjects,
    assignedSuppliers,
    dateFormat,
    dateTimeFormat,
    timezone,
    isAuthorized,
    isAuthorizedPetrohub,
    isClientOnHold,
    userAddressList,
    userToRoles,
    userContactList,
    isPetroHubUser,
    userGlobalFilterPetroHub,
  };
};
export const getUserTimezone = (state) => {
  const { loginUser } = state.auth;
  const timezone = loginUser?.user?.Timezone || '';
  return timezone;
};
export default useAuth;
